import settings from "./settings";

export default {
    namespaced: true,

    modules: {
        settings
    },
};
